import { generateUtilityClasses } from '@mui/material';

export const tableContainerClasses = generateUtilityClasses('TableContainer', ['root']);
